/**
 * Created by zhr
 */
import {returnIframeUrl} from "../../../../lib/http";

export const searchExport = {
    // createUrl: function(data) {
    //
    // },
    // returnIframeUrl: function(u, obj) {
    //     let str = '?';
    //     for( let a in obj) {
    //         str += (a + '=' + obj[a] + '&')
    //     }
    //     str = str.substring(0,str.length - 1);
    //     return u + str;
    // },
    export: function (id, that) {
        that.find('.export-btn')[0].href = returnIframeUrl('/export_queryparams/', {table_id: id});
    }
};



// WEBPACK FOOTER //
// app/components/dataGrid/data-table-toolbar/expert-search-export/search-export.js